module.exports = __webpack_public_path__ + "img/fi-rr-angle-left.2191ac75.svg";